import clsx from "clsx";
// import parse from 'html-react-parser';

const Post = ({ post }) => {
  if (!post) return null;
  return (
    <div className={clsx("mt-4")}>
      <h2 className={clsx("text-2xl")}>{post.post_title}</h2>
      <p className={clsx("text-sm")}>
        <small>{post.post_date}</small>
      </p>
      <p>{post.excerpt}</p>
    </div>
  );
};

export default Post;
